"use strict";
/**
 * THE THREE COUNTERS A UHID CAN BE ISSUED FROM.
 *
 * The hospital registers patients under exactly three series — OPD, CR and
 * Children — and each runs its own UHID range so a number issued at one desk
 * can never collide with one issued at another.
 *
 * This list lived in `frontend/.../UhidGeneratorTab.tsx` as an exported const,
 * with the same three strings re-spelled as a bare `z.enum(['OPD','CR',
 * 'CHILDREN'])` in four separate request/response contracts. It is stated once
 * here for the same reason `COUNTER_TYPES` is: the backend enforces it and the
 * frontend renders it, and three strings maintained in five places is how a
 * series ends up valid on one side and rejected on the other.
 *
 * `CHILDREN` is the stored value; "Children" is the only thing a desk sees.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UHID_COUNTER_TYPE_LABELS = exports.UHID_COUNTER_TYPES = void 0;
exports.allowedUhidCounterTypes = allowedUhidCounterTypes;
exports.UHID_COUNTER_TYPES = ['OPD', 'CR', 'CHILDREN'];
exports.UHID_COUNTER_TYPE_LABELS = {
    OPD: 'OPD',
    CR: 'CR',
    CHILDREN: 'Children',
};
/**
 * WHICH REGISTRATION SERIES A CASH COUNTER MAY ISSUE.
 *
 * Desk, 2026-09-08: "when any frontend user selected Consultation Counter —
 * under new patient registration should show only CR and Children Series, dont
 * show OPD series".
 *
 * NULL AND EMPTY BOTH MEAN "ALL THREE", and that is the load-bearing part of
 * this design rather than a convenience. The hospital named ONE desk. Every
 * other counter — OPD, Childrens, Lab, Main Cash — and every operator who has
 * picked no counter at all must keep seeing what they see today, because a
 * series wrongly hidden is a patient who cannot be registered, and nobody
 * asked for those desks to change. So the restriction is opt-in per counter:
 * an unset counter is unrestricted, which is exactly the state every counter
 * is in until an administrator says otherwise.
 *
 * Stored on the COUNTER rather than derived from its code, because `code` and
 * `name` are tenant data an administrator can rename from the Cash Counter
 * screen — the same objection `Role.defaultCounterId` was created to answer
 * when the alternative was matching on a role NAME.
 */
function allowedUhidCounterTypes(configured) {
    if (!configured || configured.length === 0)
        return exports.UHID_COUNTER_TYPES;
    const allowed = exports.UHID_COUNTER_TYPES.filter((type) => configured.includes(type));
    /*
      A configured list that matches nothing valid falls back to ALL THREE rather
      than to none. The failure mode this guards is a desk locked out of
      registering anybody — by a typo in a seed, by a value written before this
      enum grew a member, by a row edited in SQL. "Show everything" is recoverable
      in the next second; "show nothing" is a queue at the counter.
    */
    return allowed.length > 0 ? allowed : exports.UHID_COUNTER_TYPES;
}
//# sourceMappingURL=uhid-counter.js.map